import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaPaperPlane } from "react-icons/fa";

export default function SendMessageNode({ data, selected }) {
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[200px] transition-shadow ${
        selected ? "border-blue-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-blue-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-blue-500">
        <FaPaperPlane size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Send Message</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5">
        {data.message ? (
          <p className="text-xs text-ink-primary line-clamp-3">{data.message}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to add message</p>
        )}
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-blue-500 !border-2 !border-white"
      />
    </div>
  );
}
